<template>
    <div></div>
</template>

<script>
  export default {
    name: 'Midjourney'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ai/Midjourney.vue